export function mapCard(cols, cardId, fn) {
  return cols.map((col) => {
    const i = col.cards.findIndex(c => c.id === cardId);
    if (i === -1) return col;
    const cards = [...col.cards];
    cards[i] = fn(cards[i]);
    return { ...col, cards };
  });
}

function removeCard(cols, cardId) {
  let removed;
  let fromColId;

  const out = (cols || []).map((col) => {
    const cards = Array.isArray(col.cards) ? [...col.cards] : [];
    const i = col.cards.findIndex(c => c.id === cardId);
    if (i === -1) return col;

    [removed] = cards.splice(i, 1);
    fromColId = col.id;
    return { ...col, cards };
  });
  return { cols: out, removed, fromColId };
}

function insertRelative(cards, item, beforeId, afterId) {
  const next = Array.isArray(cards) ? [...cards] : [];
  if (beforeId) {
    const i = next.findIndex(c => c.id === beforeId);
    if (i !== -1) { next.splice(i + 1, 0, item); return next; }
  }
  if (afterId) {
    const i = next.findIndex(c => c.id === afterId);
    if (i !== -1) { next.splice(i, 0, item); return next; }
  }
  next.push(item);
  return next;
}

export function moveCardByNeighbors(
  cols,
  {
    card,
    toColId,
    beforeId = null,
    afterId = null,
  },
) {
  const { cols: without, removed } = removeCard(cols, card.id);
  const patched = removed ? { ...removed, id_unitary_operation: toColId } : removed;

  let toColFound = false;

  const next = without.map((col) => {
    if (col.id !== toColId) return col;
    toColFound = true;
    return { ...col, cards: insertRelative(col.cards, patched, beforeId, afterId) };
  });

  return toColFound ? next : cols;
}
